var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwsSolution5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4562 54.5855L34.3109 63.7451C37.1559 65.3887 40.662 65.3887 43.5071 63.7451L59.3617 54.5855C61.5537 53.3191 62.9039 50.9798 62.9039 48.4483V23.959L62.5411 24.3758C61.7884 25.2408 60.8974 25.9751 59.9045 26.5487Lnan nanL59.9045 26.5487L56.9051 28.2815L50.9064 31.7471L42.8502 36.4014C40.4116 37.8102 37.4064 37.8102 34.9678 36.4014L26.9115 31.7471L20.9128 28.2815L17.9134 26.5487Lnan nanL17.9134 26.5487C16.9204 25.9751 16.029 25.2414 15.2749 24.3774L14.9141 23.9639L14.9141 48.4483C14.9141 50.9798 16.2642 53.3191 18.4562 54.5855Z",
    fill: "url(#paint0_linear_2137_19355)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4562 54.5855L34.3109 63.7451C37.1559 65.3887 40.662 65.3887 43.5071 63.7451L59.3617 54.5855C61.5537 53.3191 62.9039 50.9798 62.9039 48.4483V23.959L62.5411 24.3758C61.7884 25.2408 60.8974 25.9751 59.9045 26.5487Lnan nanL59.9045 26.5487L56.9051 28.2815L50.9064 31.7471L42.8502 36.4014C40.4116 37.8102 37.4064 37.8102 34.9678 36.4014L26.9115 31.7471L20.9128 28.2815L17.9134 26.5487Lnan nanL17.9134 26.5487C16.9204 25.9751 16.029 25.2414 15.2749 24.3774L14.9141 23.9639L14.9141 48.4483C14.9141 50.9798 16.2642 53.3191 18.4562 54.5855Z",
    fill: "url(#paint1_linear_2137_19355)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8473 36.8918C40.4088 38.3005 37.4038 38.3004 34.9653 36.8916L16.1699 26.0331C14.4199 25.0221 14.4199 22.4961 16.1699 21.4851L34.9648 10.6269C37.4035 9.218 40.4089 9.21807 42.8476 10.6271L61.6427 21.4867C63.3926 22.4978 63.3925 25.0238 61.6425 26.0347L42.8473 36.8918Z",
    fill: "url(#paint2_linear_2137_19355)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8184 26.898C45.8184 28.4853 44.5316 29.772 42.9444 29.772C41.3571 29.772 40.0703 28.4853 40.0703 26.898C40.0703 25.3107 41.3571 24.0239 42.9444 24.0239C44.5316 24.0239 45.8184 25.3107 45.8184 26.898Z",
    fill: "url(#paint3_linear_2137_19355)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8184 26.898C45.8184 28.4853 44.5316 29.772 42.9444 29.772C41.3571 29.772 40.0703 28.4853 40.0703 26.898C40.0703 25.3107 41.3571 24.0239 42.9444 24.0239C44.5316 24.0239 45.8184 25.3107 45.8184 26.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2504 37.2746C57.2504 47.4089 49.0349 55.6244 38.9006 55.6244C28.7663 55.6244 20.5508 47.4089 20.5508 37.2746C20.5508 27.1403 28.7663 18.9248 38.9006 18.9248C49.0349 18.9248 57.2504 27.1403 57.2504 37.2746Z",
    fill: "url(#paint4_linear_2137_19355)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8057 28.5037C51.1561 27.5499 49.8231 27.5558 48.8708 28.2076C47.6112 29.0697 46.2594 29.5172 44.9921 29.2226C42.8048 28.7141 41.3667 26.1109 40.7503 23.3236C40.5498 22.4169 39.8302 21.6733 38.9017 21.6733V21.6733C30.2855 21.6733 23.3008 28.6581 23.3008 37.2742C23.3008 39.3447 23.7041 41.3211 24.4366 43.1289C24.6188 43.5787 25.087 43.8268 25.5723 43.8268V43.8268C26.2994 43.8268 26.5459 41.4256 26.7985 38.9634C26.846 38.5009 26.8937 38.0362 26.9448 37.5849C27.1254 35.9916 28.4272 36.0335 29.2053 37.4355C30.9146 40.5154 32.1181 38.4694 32.7226 37.4417C33.0165 36.9419 33.1688 36.683 33.1688 37.3712C33.1688 39.2699 32.2399 44.287 30.8363 48.8591C30.5689 49.7303 30.888 50.6935 31.6961 51.115C33.8515 52.2394 36.3023 52.8751 38.9017 52.8751C44.7503 52.8751 49.8472 49.6567 52.5181 44.8944C52.5444 44.8474 52.5053 44.7908 52.452 44.7987V44.7987C48.0041 45.4557 42.5906 46.2554 42.5906 43.4919C42.5906 42.8958 43.4794 42.3018 44.4351 41.663C45.7439 40.7883 47.1785 39.8295 46.6289 38.666C46.0314 37.4012 45.5026 35.9096 46.655 35.1166C48.1641 34.0781 49.9305 33.0792 51.5876 32.2748C52.5714 31.7972 53.0671 30.6377 52.5341 29.6827C52.3084 29.2783 52.0653 28.8849 51.8057 28.5037Z",
    fill: "url(#paint5_linear_2137_19355)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1841 37.3408C50.1611 37.4319 50.1518 37.5263 50.1628 37.6196C50.285 38.6631 51.1486 40.0278 52.3837 41.6053C52.8529 42.2045 53.781 42.0463 53.9774 41.311C54.3213 40.0234 54.5046 38.6703 54.5046 37.2743C54.5046 36.1274 54.3809 35.0095 54.146 33.933C54.0071 33.2963 53.2757 33.017 52.7668 33.4242C51.5124 34.4278 50.5961 35.7102 50.1841 37.3408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1841 37.3408C50.1611 37.4319 50.1518 37.5263 50.1628 37.6196C50.285 38.6631 51.1486 40.0278 52.3837 41.6053C52.8529 42.2045 53.781 42.0463 53.9774 41.311C54.3213 40.0234 54.5046 38.6703 54.5046 37.2743C54.5046 36.1274 54.3809 35.0095 54.146 33.933C54.0071 33.2963 53.2757 33.017 52.7668 33.4242C51.5124 34.4278 50.5961 35.7102 50.1841 37.3408Z",
    fill: "url(#paint6_linear_2137_19355)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2137_19355",
    x1: 38.909,
    y1: 23.959,
    x2: 38.909,
    y2: 64.9778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1681FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D4D96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2137_19355",
    x1: 38.909,
    y1: 25.2863,
    x2: 45.1933,
    y2: 52.4255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19D78B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#227AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2137_19355",
    x1: 38.9062,
    y1: 9.57028,
    x2: 38.9062,
    y2: 37.9482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EFFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19D78B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2137_19355",
    x1: 42.9444,
    y1: 24.2099,
    x2: 43.9557,
    y2: 27.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#227AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19D78B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2137_19355",
    x1: 38.9006,
    y1: 20.1124,
    x2: 45.3575,
    y2: 43.9465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#227AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19D78B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2137_19355",
    x1: 38.0263,
    y1: 21.6733,
    x2: 38.0263,
    y2: 52.8751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CE400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2137_19355",
    x1: 52.3314,
    y1: 33.2334,
    x2: 52.3314,
    y2: 41.9729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CE400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsSolution5);
export default __webpack_public_path__ + "static/media/awsSolution5.51af414f7483f24a7315fb7cae5101ea.svg";
export { ForwardRef as ReactComponent };